module.exports = __webpack_public_path__ + "img/1a.61e31a80.jpg";